export function createOpfsWorker() {
    return new Worker(new URL('./opfs-worker.js', import.meta.url), { type: 'module' });
}
//# sourceMappingURL=opfsWorkerFactory.js.map